import { NewsModel } from '@modules/news/news-model';

const { fields } = NewsModel;

export default [
  fields.title,
  fields.subtitle,
  fields.contentHtml,
  fields.description,
  fields.sourceUrl,
  fields.media,
  fields.status,
  fields.propertyOwner,
];
